// Display currency for the public pricing page is SERVER-RESOLVED and
// non-selectable: the page calls GET /public/pricing/geo, and the backend
// derives the currency from the request's network location (CloudFront viewer
// country — Canada sees CAD, everyone else USD, constrained to a currency the
// catalog can sell). The former device-based guess (timezone/locale), the
// CAD/USD switcher, and the persisted localStorage choice are gone: device
// signals mislabel real visitors, and the currency is a pricing fact, not a
// preference. Never used for charging — the billing currency is stamped from
// the actual Stripe subscription at first checkout.

/** Fallback when the geo endpoint is unreachable. Mirrors ems-api DEFAULT_BILLING_CURRENCY. */
export const BASE_DISPLAY_CURRENCY = "cad";
